

































































	import { Component, tlLogDebug } from "../../../Infrastructure/CorBase/CoreBase";
    import { BaseTLDetailComponent, ComponentService, AxiosResponse } from "../../../Infrastructure/CorBase/CoreBase";
	


	@Component
	export default class ReceiverAdd extends BaseTLDetailComponent {

		componentService: ComponentService = new ComponentService();
		isBusy = false;

		formData = {			
			adoptionCode: '',
			idTenant: this.$store.state.idTenant
		}

		goBack() {			
			this.$router.push({ name: 'ReceiverList' });
		}

		created() {			
		}

		acceptProvisionComponent() {

			tlLogDebug('acceptProvision',this.formData);
			super.callActionAndShowErrorInfoMessage(this.componentService.addComponent(this.formData), this.$t('receiverDetail.receiverAdd').toString());		
		}

		mounted() {		
			if (this.$route.query.AC != undefined) {
				this.formData.adoptionCode = this.$route.query.AC.toString();
			}
			else if (this.$router.currentRoute.params.ac != undefined) {
				this.formData.adoptionCode = this.$router.currentRoute.params.ac;
            }
			else {
				this.formData.adoptionCode = this.$store.state.lastRoutePageQuery['AC'];
					//this.$route.params.ac;
			}
			super.callActionAndShowErrorInfoMessage(this.componentService.addComponent(this.formData), this.$t('receiverDetail.receiverAdd').toString());
		}

        protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
            return super.NoCall()
        }

        refreshItems(items: any, refreshData: any): any {
            return items;
        }


	}
